import React from "react";
import { Advertising } from "./ads/Advertising";
import { Criteria } from "./Criteria";
import { Newsletter } from "./Newsletter";
import { RssFeed } from "./RssFeed";
import { Ad } from "./ads/Ad";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { criteriaGroupsType } from "../../common/types/search/search";

interface NewsSidebarProps {
	criteria: criteriaGroupsType;
	namespace: string;
	searchesEnabled: boolean;
}

export function NewsSidebar({
	criteria,
	namespace,
	searchesEnabled,
}: NewsSidebarProps) {
	const { isMobile } = useAccessWindowSize();

	return (
		<aside id="news-filter-bar" className="search-results-sidebar">
			<Advertising advertisingCodes={["sidebar_1"]} />
			<Criteria
				searchesEnabled={searchesEnabled}
				criteria={criteria}
				namespace={namespace}
			/>
			<Advertising
				advertisingCodes={["sidebar_2", "sidebar_3", "sidebar_4"]}
			/>
			<Newsletter />
			<RssFeed />
			{!isMobile && <Ad code="sidebar_5" sticky />}
		</aside>
	);
}
